// extracted by mini-css-extract-plugin
module.exports = {"root":"SalesChartFilter_root__WnAKz","submitButton":"SalesChartFilter_submitButton__32DxU"};